import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.411 8.423a.833.833 0 0 1 1.179-1.179l2.5 2.5a.833.833 0 0 1 0 1.179l-2.5 2.5a.833.833 0 0 1-1.179-1.179l1.078-1.077H5.334a.833.833 0 0 1 0-1.667h7.155z" }, null, -1)
  ])))
}
export default { render: render }